// extracted by mini-css-extract-plugin
export default {"link":"link__VIKmak"};